//CSS
import '../../Components/Page/Page.css'
import SecHeader from '../../Components/SecHeader/SecHeader';
import '../Business Model/BusinessModel.css';

//React
import React from 'react';


const RevenueScenario: React.FC = () => {
    return (
        <div className='quoteSection'>
            <SecHeader title="Revenue Scenario (Large Co.)" />
            <div className="splitContainer">
                <div className="quoteContainer">
                    <div className="quoteBackground">
                        <text className="quote">Using one of the 25 global car companies (GM is #6) as an example – since Wankel in the 1960 licensed IP to all of them,   – including to GM, a license for exclusivity and prototyping for $50-million, ($400-million in todays money)</text>
                    </div>
                </div>
                <div className="description">
                    <p>
                        <div>
                            <b>1) Software (E-SPEC SaaS) & Data</b>
                            <br />$1-million for 3-yrs. access to our data (R&D + Current) + design tools to quickly see what they gain with ELF-Tech, – and what they risk by not using it
                            <br />
                        </div>
                        <div>
                            <b>2) Parts’ CADs Sales (From Our Growing Library)</b>
                            <br />$10-million for prototyping and building test engines, and
                            $100-million for US exclusivity for 2 years (if desired)

                            <br />
                        </div>
                        <div>
                            <b>3) Prototyping Licenses (+/- Exclusivity)</b>
                            <br />E-SPEC users can explore how ELF-Tech innovations give their product the best edge in power, weight, efficiency, emissions and costs. This will become the “must use” global gold standard, and it will be the only product with all the ELF-Tech design data.<br />
                        </div>
                        <div>
                            <b>4) Production Licenses</b>
                            <br />From our library of parts Computer Aided Designs (CAD)s<br />
                        </div>
                        <div>
                            <b>5) Consulting (if desired)​</b>
                        </div>
                    </p>
                </div>

            </div>
        </div>
    );
};

export default RevenueScenario;